/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Cloud_LabelInputs */

const en_media_import_cloud_label = /** @type {(inputs: Media_Import_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud Storage URL`)
};

const fr_media_import_cloud_label = /** @type {(inputs: Media_Import_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL du stockage cloud`)
};

const de_media_import_cloud_label = /** @type {(inputs: Media_Import_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud-Speicher-URL`)
};

const it_media_import_cloud_label = /** @type {(inputs: Media_Import_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL di archiviazione cloud`)
};

const ru_media_import_cloud_label = /** @type {(inputs: Media_Import_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL облачного хранилища`)
};

const es_media_import_cloud_label = /** @type {(inputs: Media_Import_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de almacenamiento en la nube`)
};

const zh_cn2_media_import_cloud_label = /** @type {(inputs: Media_Import_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`云存储 URL`)
};

const ja_media_import_cloud_label = /** @type {(inputs: Media_Import_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クラウドストレージURL`)
};

const hi_media_import_cloud_label = /** @type {(inputs: Media_Import_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लाउड स्टोरेज यूआरएल`)
};

const pt_pt2_media_import_cloud_label = /** @type {(inputs: Media_Import_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de armazenamento em nuvem`)
};

/**
* | output |
* | --- |
* | "Cloud Storage URL" |
*
* @param {Media_Import_Cloud_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_cloud_label = /** @type {((inputs?: Media_Import_Cloud_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Cloud_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_cloud_label(inputs)
	if (locale === "de") return de_media_import_cloud_label(inputs)
	if (locale === "it") return it_media_import_cloud_label(inputs)
	if (locale === "ru") return ru_media_import_cloud_label(inputs)
	if (locale === "es") return es_media_import_cloud_label(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_cloud_label(inputs)
	if (locale === "ja") return ja_media_import_cloud_label(inputs)
	if (locale === "hi") return hi_media_import_cloud_label(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_cloud_label(inputs)
	return en_media_import_cloud_label(inputs)
});